module.exports = __webpack_public_path__ + "img/mowen1.9fd05784.png";